import { fromFetch } from 'rxjs/fetch';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { withJwt } from '../../utils/with-jwt';
import { accountsEnvironment } from './accounts-environment';
import { CompanySettings } from './schemas/company-settings.schema';
import { companySettingsRequestSchema } from './schemas/request-schemas.schema';

export function postCompanySettings(companySettings: CompanySettings) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(accountsEnvironment.companySettingsUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(
          companySettingsRequestSchema.parse(companySettings)
        ),
      })
    )
  ).pipe(ignoreData());
}
